import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { UploadIcon } from 'lucide-react';
import MediaTable from './media-table/table';
import UploadMediaModal from './upload-media-modal';
import { useAppSearchParams } from '@/hooks/use-app-search-params';
import type { Organisation } from '@/services/types';

type Props = {
  data: Organisation | undefined;
  componentType?: 'verify' | 'edit';
};

export default function MediaFilesPage(props: Props) {
  const { data, componentType = 'verify' } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const params = useAppSearchParams();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div className={`max-w-4xl p-6 font-grotesk ${componentType === 'verify' ? 'mx-auto' : ''}`}>
      <div className='space-y-6'>
        <div>
          <h1 className='text-2xl font-bold'>Media Files</h1>
          <p className='mt-2 text-[#545454]'>
            Upload relevant media files such as news and other media related to
            your organisations
          </p>
          <p className='mt-1 italic text-gray-500'>
            File size should not be more than 2MB
          </p>
        </div>

        <div className='flex items-center justify-center rounded-md bg-[#f3f4f6] p-6 text-[#2658AB]'>
          <Button
            variant='outline'
            className='flex items-center gap-2'
            onClick={handleOpenModal}
          >
            <UploadIcon className='h-4 w-4' />
            Add Media Files
          </Button>
        </div>

        { componentType === 'verify' && <div className='flex justify-between'>
          <Button
            variant='outline'
            onClick={() => params.set({ view: 'expertise' })}
          >
            Back
          </Button>
          <Button onClick={() => params.set({ view: 'projects' })}>Next</Button>
        </div> }

        <MediaTable 
          data={data?.media || []} 
          totalItems={data?.media?.length || 0}
          organisationId={data?.id}
        />
      </div>

      <UploadMediaModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        organisationId={data?.id}
      />
    </div>
  );
}
